
const updateLead = async ({ leadId, language }: { leadId: string, language: string }) => {
	try {
		const response = await fetch(process.env.APP_PATH + '/api/clear-choice/update-lead/', {
			method: 'PATCH',
			body: JSON.stringify({
				leadId,
        language
			}),
		});

		const data = await response.json();

		return data;
	} catch (error) {
		if (error instanceof Error) {
			throw new Error(`Failed Updating Lead`);
		}
		return [];
	}
};

export { updateLead };
